import axios from "axios";
import {api} from "@/api";
import Common from '../helpers/Common'

export const CheckMixin = {
  methods: {
    // 테스팅용. Mobile/PC 구분 및 사내 IP 체크
    // public/js/bmwplus_mobile_app_api_v1.0.4.js function isRunnugInApp
    // global isRunningInApp
    checkApp(){
      let isApp = false;
      if(/inAppBrowser/i.test(navigator.userAgent)) isApp = true;
      if(!isApp) isApp = typeof window.android !== 'undefined';
      if(!isApp) isApp = typeof window.webkit !== 'undefined';

      this.$store.state.isApp = isApp;
    },

    // 테스트 사이트 여부 (사내에서는 웹 접속으로 구독기능 실행 가능)
    checkDev() {
      axios.get(`${api.users}/getClientIp`)
        .then((res) => {
          
          const ip = res.data.ip;
          const ips = Common.devIps;
          const isProduction = Common.isProduction();
          
          if( (ips.includes(ip)) && (!(isProduction))) this.$store.state.isDev = true;
        })
    },

    // 2021-02-09 jeon
    // checkApp,checkDev는 route 이동 후 created 에서 실행된다. 
    // route에서의 isApp,isDev는 false다.
    // My BMW Prime, 해지신청 페이지로 이동시 isApp,isDev와 상관없이 route
    // 그러므로 My BMW Prime, 해지신청 페이지에서 isApp,isDev 체크를 해야한다.
    CheckAppDev(){
      //app X dev X = route notApp
      if( (!this.$store.state.isApp) && (!this.$store.state.isDev) ) {
        return this.$router.push('/notApp');
      }
        
    },

    // plus 등록 유저 확인(vuex 데이터) & 미가입자 일 경우 안내메세지 반환
    checkUserPlus() {
      const plusId = this.$store.state.user.plus_id;
      if (plusId) return true;
      else return false;
    },

    chechUserVtg() {
      const vtgId = this.$store.state.user.vtg_id;
      if (vtgId) return true;
      else return false;
    }

  }
}